module.exports = __webpack_public_path__ + "static/media/Bitcoin.aded1286.jpg";